import i18n from '../i18n';

export const formatDate = (date) =>
  new Intl.DateTimeFormat(i18n.language, { dateStyle: 'medium' }).format(new Date(date));

export const formatTime = (date) =>
  new Intl.DateTimeFormat(i18n.language, { timeStyle: 'short' }).format(new Date(date));

export const formatDateTime = (date) =>
  new Intl.DateTimeFormat(i18n.language, { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(date));

export const formatCurrency = (amount, { decimals = 0 } = {}) =>
  new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(amount);

export function maskPhone(e164) {
  if (!e164 || e164.length < 4) return e164 ?? '';
  const last4 = e164.slice(-4);
  if (e164.startsWith('+91') && e164.length === 13) {
    return `+91 •••• ${last4}`;
  }
  const masked = e164.slice(0, e164.length - 4).replace(/[0-9]/g, '•');
  return `${masked}${last4}`;
}

export const formatNumber = (value) =>
  new Intl.NumberFormat(i18n.language).format(value);
